module.exports = __webpack_public_path__ + "static/media/ico-news.6337389e.svg";